export default __webpack_public_path__ + "assets/icons/kr.a74ba156.svg";